import React from "react"

const SearchBar = (props) => {
  const onFocus = (target) => props.onFocus && props.onFocus(target)
  const handleInput = (target) => props.handleInput && props.handleInput(target)
  const onKeyUp = (target) => props.onKeyUp && props.onKeyUp(target)

  return (
    <React.Fragment>
      <input
        autoComplete="off"
        autoFocus={props.autoFocus}
        id="searchForm_TextBox"
        type="text"
        className="search-input react-elem"
        placeholder={props.placeholderText ?? "Søg..."}
        onFocus={(e) => onFocus(e.currentTarget)}
        onInput={(e) => handleInput(e.currentTarget)}
        onKeyUp={(e) => onKeyUp(e)}
      ></input>
      <div id="searchForm_Icon" className="search-icon"></div>
    </React.Fragment>
  )
}

export default SearchBar
